import React from "react";
import SectionHeader from "@/components/SectionHeader";
import MetricRow from "@/components/MetricRow";
import WorkCard from "@/components/WorkCard";

const INFLUENCERS = [
  {
    index: "01",
    tag: "Finance Expert · @thehimanichaudhary",
    title: "Why personal loans are outdated.",
    caption: "The smarter way to borrow without breaking your investments.",
    image: "01 Loan Against Mutual Fund - Influencer Campaign thehimanichaudhary.jpg",
    link: "https://www.instagram.com/p/DNVUasPTcl7/",
  },
  {
    index: "02",
    tag: "Finance Expert · @financewizardcl",
    title: "The wealth-building secret the richest Indians don't talk about.",
    caption: "And why it works, even for retail investors.",
    image: "02 Loan Against Mutual Fund - Influencer Campaign financewizardcl.jpg",
    link: "https://www.instagram.com/p/DM-T8JKTzWt/",
  },
  {
    index: "03",
    tag: "Finance Expert · @idea____man",
    title: "How billionaires stay liquid.",
    caption: "The borrowing strategy Elon Musk uses (and why you should too).",
    image: "03 Loan Against Mutual Fund - Influencer Campaign idea____man.jpg",
    link: "https://www.instagram.com/p/DMpyjBEviSd/",
  },
  {
    index: "04",
    tag: "Finance Expert · @ji_nitinjoshi",
    title: "Fund emergencies without selling your assets.",
    caption: "The wealth hack millionaires use.",
    image: "04 Loan Against Mutual Fund - Influencer Campaign ji_nitinjoshi.jpg",
    link: "https://www.instagram.com/p/DNN5-h4zeDp/",
  },
  {
    index: "05",
    tag: "Travel · @escapetolandscapes",
    title: "Fund your dream trip without pausing investments.",
    caption: "Travel-first storytelling for portfolio-first wisdom.",
    image: "05 Loan Against Mutual Fund - Influencer Campaign escapetolandscapes.jpg",
    link: "https://www.instagram.com/p/DMkdIWXBDcm/",
  },
  {
    index: "06",
    tag: "Travel · @soultravel_vipan",
    title: "Travel on a budget. Keep your wealth journey alive.",
    caption: "Relatable, regional, and refreshingly honest.",
    image: "06 Loan Against Mutual Fund - Influencer Campaign soultravel_vipan.jpg",
    link: "https://www.instagram.com/p/DM1mn5CBl0E/",
  },
  {
    index: "07",
    tag: "Travel · @wanderlust_himani",
    title: "Earning well, but can't fund that overseas trip?",
    caption: "Here's what most people are missing.",
    image: "07 Loan Against Mutual Fund - Influencer Campaign wanderlust_himani.jpg",
    link: "https://www.instagram.com/p/DMzBoqFo1AX/",
  },
];

const ORGANIC = [
  {
    index: "08",
    tag: "Community Poll",
    title: "What would you do if you needed ₹1 lakh tomorrow?",
    caption: "A real-time conversation revealing the gaps in how people fund life's moments. The answer waited in the comments.",
    image: "08 Loan Against Mutual Fund - Inorganic campaign 2.jpg",
    link: "https://www.instagram.com/p/DL62nw6yc8V/",
  },
  {
    index: "09",
    tag: "Curiosity-Driven Education",
    title: "Billionaires don't sell, they borrow.",
    caption: "Demystifying ultra-high-net-worth wealth tactics for the everyday investor.",
    image: "09 Loan Against Mutual Fund - Inorganic campaign.jpg",
    link: "https://www.instagram.com/p/DMXCyXovHQd/",
  },
];

export default function CampaignsPage() {
  return (
    <>
      <SectionHeader
        eyebrow="Case Study 01"
        pageIndex="01"
        title="Paid & Organic Campaigns"
        kicker="Launch of Loan Against Mutual Funds: a smarter way to borrow without breaking your investments."
        lede="Executed an integrated paid and organic campaign using strategic influencer partnerships across two distinct audiences. The key insight: people often liquidate investments for travel and emergencies. We leveraged both finance experts (who understand the product's mechanics) and travel influencers (who understood the pain point) to build authentic, relatable narratives."
      />

      {/* Metrics */}
      <section className="mt-20">
        <MetricRow
          items={[
            { value: "5,000+", label: "Sign-ups in month 1" },
            { value: "07", label: "Influencer partners" },
            { value: "2", label: "Audience archetypes" },
            { value: "1.4×", label: "Internal target beat" },
          ]}
        />
      </section>

      {/* Influencers */}
      <section className="mx-auto max-w-[1440px] px-6 pt-28 lg:px-12">
        <div className="mb-10 flex items-end justify-between">
          <h2 className="font-serif text-3xl tracking-tight lg:text-4xl">
            Influencer <span className="italic text-[#D4A574]">partnerships</span>
          </h2>
        </div>

        <div className="grid grid-cols-1 gap-x-8 gap-y-14 md:grid-cols-2 lg:grid-cols-3">
          {INFLUENCERS.map((c) => (
            <WorkCard key={c.index} {...c} ratio="1/1" />
          ))}
        </div>
      </section>

      {/* Organic highlights */}
      <section className="mx-auto max-w-[1440px] px-6 pt-28 lg:px-12">
        <div className="mb-10">
          <p className="text-[11px] uppercase tracking-[0.3em] text-[#D4A574]">
            Organic Highlights
          </p>
          <h2 className="mt-4 font-serif text-3xl tracking-tight lg:text-4xl">
            Conversations that
            <span className="italic text-[#D4A574]"> compounded.</span>
          </h2>
        </div>
        <div className="grid grid-cols-1 gap-x-8 gap-y-14 md:grid-cols-2">
          {ORGANIC.map((c) => (
            <WorkCard key={c.index} {...c} ratio="4/3" />
          ))}
        </div>
      </section>

      {/* Pull quote */}
      <section className="mx-auto max-w-[1100px] px-6 pt-28 text-center lg:px-12">
        <p className="font-serif text-2xl italic leading-snug text-[#EDE4D3]/85 md:text-3xl lg:text-4xl">
          &ldquo;The right voices, telling the right story, to the right audiences. That&rsquo;s when paid spend becomes <span className="text-[#D4A574]">earned trust</span>.&rdquo;
        </p>
      </section>
    </>
  );
}
